export enum FiltersTypes {
  ROLES = "roles",
  REGIONS = "regions",
}
